import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import SVG from 'components/widgets/icons/svg';

const services = [
  'Auto svcs paused 3m',
  'Auto svcs pending continue 3m',
  'Auto svcs pending pause 3m',
  'Auto svcs pending stop 3m',
  'Auto svcs stopped 3m'
];

export default function MonitoringAlertDetails({ monitoringAlert }) {
  const isAutoSrvcs = _.includes(services, monitoringAlert.trigger);
  const isDiskSpace = _.startsWith(monitoringAlert.trigger, 'Free space');
  
  // Don't show the monitoring alert details if trigger was not auto svcs stopped or disk space usage
  if (!isAutoSrvcs && !isDiskSpace) return null;

  return (
    <div className="triage-option-header triage-alert-value">
      <SVG src="svg/monitoring-alert.svg" className="monitoring-alert triage-option-icon" />
      <span>{monitoringAlert.value}</span>
    </div>
  );
}

MonitoringAlertDetails.propTypes = {
  monitoringAlert: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/monitoring-alert-details.js